export default __webpack_public_path__ + "static/media/SANTOSH KUMAR SAHU.1860c1c6.png";